import Panel from "@magicware/dashboard/Panel";
import { buildForm } from "@magicware/forms/builder";
import Form, { FormImplementationProps } from "@magicware/forms/components/Form";
import FormGrid from "@magicware/forms/components/FormGrid";
import FormTextField from "@magicware/forms/mui/FormTextField";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { updateDetail } from "../../redux/apiServerVersions/apiServerVersionsReducer";
import { ApiServerVersionModelDetail, ApiServerVersionModelUpdate } from "../../services/api/apiServerVersions";
import { FormParametersAutocomplete } from "../parameters/FormParametersAutocomplete";

export const apiServerVersionForm = buildForm<ApiServerVersionModelDetail>()(() => ({
    props: {
        remove: ["id", "version"],
        extra: [],
    },
    transformations: {
        toForm: { fromModel: (h, m: ApiServerVersionModelDetail) => ({ ...h.fromModel(m) }) },
        formTo: {
            update: (h, f, m: ApiServerVersionModelDetail): ApiServerVersionModelUpdate => ({
                ...h.toUpdateEntity(f, m),
            }),
        },
        toReduxUpdateModel: (h, f): Partial<ApiServerVersionModelDetail> => ({
            ...h.removeExtra(f),
        }),
    },
    updateReduxModel: updateDetail,
    schema: (_, t) => ({
        name: yup.string().required(t("name-is-required")),
        parameterList: yup.array().default([]),
        notes: yup.string(),
    }),
}));

const f = apiServerVersionForm.f;

export type ApiServerVersionFormOnSubmit = FormImplementationProps<typeof f>["onSubmit"];

export default function ApiServerVersionForm(props: FormImplementationProps<typeof f>) {
    const { t } = useTranslation();
    return (
        <Form validationSchema={apiServerVersionForm.validationSchema} {...props}>
            <Panel>
                <FormGrid>
                    <FormTextField f={f} field="name" label={t("name-label")} autoFocus={props.autoFocus} />
                    <FormTextField f={f} field="notes" label={t("notes-label")} multiline />
                    <FormParametersAutocomplete
                        f={f}
                        field="parameterList"
                        label={t("supported-parameters-label")}
                        filter={{}}
                        limitTags={10}
                        multiple
                        fullOption
                    />
                </FormGrid>
            </Panel>
        </Form>
    );
}
